import React from 'react'

function Loading() {
  return (
    <div className="flex items-center justify-center h-full w-full bg-gray-900 fixed top-0 left-0" style={{height: '100vh', width: '100vw', zIndex: 100000}}>
        <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-orange-600 mb-4"></div>
        <div className="text-lg text-gray-700">Carregando...</div>
        </div>
  </div>
  )
}

export default Loading